
import { Component, Vue } from 'vue-property-decorator'
import { campsiteDetailsContainer } from '~/apps/campsite-details/inversify.config'
import { CampsiteDetailsRepository } from '~/apps/campsite-details/repositories'
import { CampsiteDetails } from '~/apps/campsite-details/types'

@Component<PostReviewPage>({
  layout: 'user-account',
  head: function () {
    return this.head()
  },
  async asyncData(ctx) {
    const { params } = ctx
    const repository = campsiteDetailsContainer.get(CampsiteDetailsRepository)
    const campsite = await repository.get(
      params.campsite as string,
      params.lang,
    )
    return { campsite }
  },
})
export default class PostReviewPage extends Vue {
  head() {
    return {
      meta: [
        {
          hid: 'robots',
          name: 'robots',
          content: 'noindex',
        },
      ],
    }
  }

  campsite: CampsiteDetails | null = null

  get campsiteSlug() {
    return this.$route.params.campsite
  }

  get token() {
    return (this.$route.query.verify as string) || ''
  }
}
